import { useQuery } from "@tanstack/react-query";
import { analyticsService } from "@/services/analyticsService";

/** Backend v2.1 (Sprint 4.3) Analytics Read Model - structured DTOs, not the Sprint 3.1-era debug string. */
export function useAnalyticsSnapshot(portfolioId: string) {
  return useQuery({
    queryKey: ["analytics", "snapshot", portfolioId],
    queryFn: () => analyticsService.getAnalytics(portfolioId),
  });
}

export function usePerformanceMetrics(portfolioId: string) {
  return useQuery({
    queryKey: ["analytics", "performance", portfolioId],
    queryFn: () => analyticsService.getPerformanceMetrics(portfolioId),
  });
}
